import {g as getDefaultExportFromCjs, c as createCommonjsModule, a as commonjsGlobal} from "./common/_commonjsHelpers-4f955397.js";
import React from "react";
var ReactCrop_min = createCommonjsModule(function(module, exports) {
  /*! For license information please see ReactCrop.min.js.LICENSE.txt */
  !function(e, t) {
    module.exports = t(React);
  }(commonjsGlobal, function(e) {
    return (() => {
      var t = {
        418: (e2) => {
          var t2 = Object.getOwnPropertySymbols, r2 = Object.prototype.hasOwnProperty, o2 = Object.prototype.propertyIsEnumerable;
          function i2(e3) {
            if (e3 == null)
              throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(e3);
          }
          e2.exports = function() {
            try {
              if (!Object.assign)
                return false;
              var e3 = new String("abc");
              if (e3[5] = "de", Object.getOwnPropertyNames(e3)[0] === "5")
                return false;
              for (var t3 = {}, r3 = 0; r3 < 10; r3++)
                t3["_" + String.fromCharCode(r3)] = r3;
              if (Object.getOwnPropertyNames(t3).map(function(e4) {
                return t3[e4];
              }).join("") !== "0123456789")
                return false;
              var o3 = {};
              return "abcdefghijklmnopqrst".split("").forEach(function(e4) {
                o3[e4] = e4;
              }), Object.keys(Object.assign({}, o3)).join("") === "abcdefghijklmnopqrst";
            } catch (e4) {
              return false;
            }
          }() ? Object.assign : function(e3, s) {
            for (var n, a, h = i2(e3), c = 1; c < arguments.length; c++) {
              for (var d in n = Object(arguments[c]))
                r2.call(n, d) && (h[d] = n[d]);
              if (t2) {
                a = t2(n);
                for (var p = 0; p < a.length; p++)
                  o2.call(n, a[p]) && (h[a[p]] = n[a[p]]);
              }
            }
            return h;
          };
        },
        251: (e2, t2, r2) => {
          r2(418);
          var o2 = r2(427), i2 = 60103;
          if (t2.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
            var s = Symbol.for;
            i2 = s("react.element"), t2.Fragment = s("react.fragment");
          }
          var n = o2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, h = {
            key: true,
            ref: true,
            __self: true,
            __source: true
          };
          function c(e3, t3, r3) {
            var o3, s2 = {}, c2 = null, d = null;
            for (o3 in r3 !== void 0 && (c2 = "" + r3), t3.key !== void 0 && (c2 = "" + t3.key), t3.ref !== void 0 && (d = t3.ref), t3)
              a.call(t3, o3) && !h.hasOwnProperty(o3) && (s2[o3] = t3[o3]);
            if (e3 && e3.defaultProps)
              for (o3 in t3 = e3.defaultProps)
                s2[o3] === void 0 && (s2[o3] = t3[o3]);
            return {
              $$typeof: i2,
              type: e3,
              key: c2,
              ref: d,
              props: s2,
              _owner: n.current
            };
          }
          t2.jsx = c, t2.jsxs = c;
        },
        893: (e2, t2, r2) => {
          e2.exports = r2(251);
        },
        427: (t2) => {
          t2.exports = e;
        }
      }, r = {};
      function o(e2) {
        var i2 = r[e2];
        if (i2 !== void 0)
          return i2.exports;
        var s = r[e2] = {
          exports: {}
        };
        return t[e2](s, s.exports, o), s.exports;
      }
      o.d = (e2, t2) => {
        for (var r2 in t2)
          o.o(t2, r2) && !o.o(e2, r2) && Object.defineProperty(e2, r2, {
            enumerable: true,
            get: t2[r2]
          });
      }, o.o = (e2, t2) => Object.prototype.hasOwnProperty.call(e2, t2), o.r = (e2) => {
        typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e2, "__esModule", {
          value: true
        });
      };
      var i = {};
      return (() => {
        o.r(i), o.d(i, {
          Component: () => u,
          containCrop: () => p,
          default: () => u,
          makeAspectCrop: () => h
        });
        var e2 = o(893), t2 = o(427);
        function r2(e3) {
          var t3, o2, i2 = "";
          if (typeof e3 == "string" || typeof e3 == "number")
            i2 += e3;
          else if (typeof e3 == "object")
            if (Array.isArray(e3))
              for (t3 = 0; t3 < e3.length; t3++)
                e3[t3] && (o2 = r2(e3[t3])) && (i2 && (i2 += " "), i2 += o2);
            else
              for (t3 in e3)
                e3[t3] && (i2 && (i2 += " "), i2 += t3);
          return i2;
        }
        const s = {
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          unit: "px"
        };
        function n(e3, t3, r3) {
          return Math.min(Math.max(e3, t3), r3);
        }
        function a(e3) {
          return e3 && e3.width && !isNaN(e3.width) && e3.height && !isNaN(e3.height);
        }
        function h(e3, t3, r3) {
          if (!e3.aspect || isNaN(e3.aspect))
            return console.warn("`crop.aspect` should be a number in order to make an aspect crop", e3), {
              ...s,
              ...e3
            };
          const o2 = {
            unit: "px",
            x: e3.x || 0,
            y: e3.y || 0,
            width: e3.width || 0,
            height: e3.height || 0,
            aspect: e3.aspect
          };
          return e3.width && (o2.height = o2.width / e3.aspect), e3.height && (o2.width = o2.height * e3.aspect), o2.y + o2.height > r3 && (o2.height = r3 - o2.y, o2.width = o2.height * e3.aspect), o2.x + o2.width > t3 && (o2.width = t3 - o2.x, o2.height = o2.width / e3.aspect), o2;
        }
        function c(e3, t3, r3) {
          return e3.unit === "%" ? {
            ...s,
            ...e3
          } : {
            unit: "%",
            aspect: e3.aspect,
            x: e3.x ? e3.x / t3 * 100 : 0,
            y: e3.y ? e3.y / r3 * 100 : 0,
            width: e3.width ? e3.width / t3 * 100 : 0,
            height: e3.height ? e3.height / r3 * 100 : 0
          };
        }
        function d(e3, t3, r3) {
          return e3.unit ? e3.unit === "px" ? {
            ...s,
            ...e3
          } : {
            unit: "px",
            aspect: e3.aspect,
            x: e3.x ? e3.x * t3 / 100 : 0,
            y: e3.y ? e3.y * r3 / 100 : 0,
            width: e3.width ? e3.width * t3 / 100 : 0,
            height: e3.height ? e3.height * r3 / 100 : 0
          } : {
            ...s,
            ...e3,
            unit: "px"
          };
        }
        function p(e3, t3, r3, o2) {
          const i2 = d(t3, r3, o2), s2 = d(e3, r3, o2);
          if (!i2.aspect)
            return i2.x < 0 ? (i2.x = 0, i2.width += i2.x) : i2.x + i2.width > r3 && (i2.width = r3 - i2.x), i2.y + i2.height > o2 && (i2.height = o2 - i2.y), i2;
          let n2 = false;
          i2.x < 0 ? (i2.x = 0, i2.width += i2.x, i2.height = i2.width / i2.aspect, n2 = true) : i2.x + i2.width > r3 && (i2.width = r3 - i2.x, i2.height = i2.width / i2.aspect, n2 = true), n2 && s2.y > i2.y && (i2.y = i2.y + (i2.height - i2.height));
          let a2 = false;
          return i2.y + i2.height > o2 && (i2.height = o2 - i2.y, i2.width = i2.height * i2.aspect, a2 = true), a2 && s2.x > i2.x && (i2.x = i2.x + (i2.width - i2.width)), i2;
        }
        const l = {
          capture: true,
          passive: false
        };
        class u extends t2.PureComponent {
          constructor() {
            super(...arguments), this.keysDown = new Set(), this.docMoveBound = false, this.mouseDownOnCrop = false, this.dragStarted = false, this.evData = {
              clientStartX: 0,
              clientStartY: 0,
              cropStartWidth: 0,
              cropStartHeight: 0,
              cropStartX: 0,
              cropStartY: 0,
              xDiff: 0,
              yDiff: 0,
              xInversed: false,
              yInversed: false,
              xCrossOver: false,
              yCrossOver: false,
              lastYCrossover: false,
              startXCrossOver: false,
              startYCrossOver: false,
              isResize: true,
              ord: "nw"
            }, this.componentRef = (0, t2.createRef)(), this.mediaWrapperRef = (0, t2.createRef)(), this.imageRef = (0, t2.createRef)(), this.cropSelectRef = (0, t2.createRef)(), this.state = {
              cropIsActive: false,
              newCropIsBeingDrawn: false
            }, this.onCropPointerDown = (e3) => {
              const {
                crop: t3,
                disabled: r3
              } = this.props, {
                width: o2,
                height: i2
              } = this.mediaDimensions, s2 = d(t3, o2, i2);
              if (r3)
                return;
              e3.cancelable && e3.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({
                preventScroll: true
              });
              const {
                ord: n2
              } = e3.target.dataset, a2 = n2 === "nw" || n2 === "w" || n2 === "sw", h2 = n2 === "nw" || n2 === "n" || n2 === "ne";
              this.evData = {
                clientStartX: e3.clientX,
                clientStartY: e3.clientY,
                cropStartWidth: s2.width,
                cropStartHeight: s2.height,
                cropStartX: a2 ? s2.x + s2.width : s2.x,
                cropStartY: h2 ? s2.y + s2.height : s2.y,
                xDiff: 0,
                yDiff: 0,
                xInversed: a2,
                yInversed: h2,
                xCrossOver: a2,
                yCrossOver: h2,
                lastYCrossover: h2,
                startXCrossOver: a2,
                startYCrossOver: h2,
                isResize: Boolean(n2),
                ord: n2 || "ne"
              }, this.mouseDownOnCrop = true, this.setState({
                cropIsActive: true
              });
            }, this.onComponentPointerDown = (e3) => {
              const {
                crop: t3,
                disabled: r3,
                locked: o2,
                keepSelection: i2,
                onChange: s2,
                zoom: n2 = 1,
                spin: h2 = 0
              } = this.props, p2 = this.mediaWrapperRef.current.firstChild;
              if (e3.target !== p2 || !p2.contains(e3.target))
                return;
              if (r3 || o2 || i2 && a(t3))
                return;
              e3.cancelable && e3.preventDefault(), this.bindDocMove(), this.componentRef.current.focus({
                preventScroll: true
              });
              const l2 = this.mediaWrapperRef.current.getBoundingClientRect();
              let u2 = 0, f = 0, g = (e3.clientX - l2.left) / n2, m = (e3.clientY - l2.top) / n2, v = h2, w = Math.abs(v * Math.PI / 180);
              v > -45 && v <= 45 || Math.abs(v) > 135 && Math.abs(v) <= 180 ? (u2 = g * Math.cos(w), f = m * Math.cos(w)) : v > 45 && v <= 135 ? (u2 = m * Math.sin(w), f = g * Math.sin(w) * -1) : v > -135 && v <= -45 && (u2 = m * Math.sin(w) * -1, f = g * Math.sin(w));
              const y = {
                unit: "px",
                aspect: t3 ? t3.aspect : void 0,
                x: u2,
                y: f,
                width: 0,
                height: 0
              };
              this.evData = {
                clientStartX: e3.clientX,
                clientStartY: e3.clientY,
                cropStartWidth: y.width,
                cropStartHeight: y.height,
                cropStartX: y.x,
                cropStartY: y.y,
                xDiff: 0,
                yDiff: 0,
                xInversed: false,
                yInversed: false,
                xCrossOver: false,
                yCrossOver: false,
                lastYCrossover: false,
                startXCrossOver: false,
                startYCrossOver: false,
                isResize: true,
                ord: "nw"
              }, this.mouseDownOnCrop = true;
              const {
                width: C,
                height: x
              } = this.mediaDimensions;
              s2(d(y, C, x), c(y, C, x)), this.setState({
                cropIsActive: true,
                newCropIsBeingDrawn: true
              });
            }, this.onDocPointerMove = (e3) => {
              const {
                crop: t3,
                disabled: r3,
                onChange: o2,
                onDragStart: i2,
                zoom: s2 = 1,
                spin: n2 = 0
              } = this.props;
              if (r3)
                return;
              if (!this.mouseDownOnCrop)
                return;
              e3.cancelable && e3.preventDefault(), this.dragStarted || (this.dragStarted = true, i2 && i2(e3));
              const {
                evData: a2
              } = this;
              let h2, p2 = (e3.clientX - a2.clientStartX) / s2, l2 = (e3.clientY - a2.clientStartY) / s2, u2 = n2, f = Math.abs(u2 * Math.PI / 180);
              if (u2 > -45 && u2 <= 45 || Math.abs(u2) > 135 && Math.abs(u2) <= 180 ? (a2.xDiff = p2 * Math.cos(f), a2.yDiff = l2 * Math.cos(f)) : u2 > 45 && u2 <= 135 ? (a2.xDiff = l2 * Math.sin(f), a2.yDiff = p2 * Math.sin(f) * -1) : u2 > -135 && u2 <= -45 && (a2.xDiff = l2 * Math.sin(f) * -1, a2.yDiff = p2 * Math.sin(f)), h2 = a2.isResize ? this.resizeCrop() : this.dragCrop(), h2 !== t3) {
                const {
                  width: e4,
                  height: t4
                } = this.mediaDimensions;
                o2(d(h2, e4, t4), c(h2, e4, t4));
              }
            }, this.onComponentKeyDown = (e3) => {
              const {
                crop: t3,
                disabled: r3,
                onChange: o2,
                onComplete: i2
              } = this.props;
              if (r3)
                return;
              this.keysDown.add(e3.key);
              let s2 = false;
              if (!a(t3))
                return;
              const h2 = this.makeNewCrop(), p2 = (navigator.platform.match("Mac") ? e3.metaKey : e3.ctrlKey) ? u.nudgeStepLarge : e3.shiftKey ? u.nudgeStepMedium : u.nudgeStep;
              if (this.keysDown.has("ArrowLeft") && (h2.x -= p2, s2 = true), this.keysDown.has("ArrowRight") && (h2.x += p2, s2 = true), this.keysDown.has("ArrowUp") && (h2.y -= p2, s2 = true), this.keysDown.has("ArrowDown") && (h2.y += p2, s2 = true), s2) {
                e3.cancelable && e3.preventDefault();
                const {
                  width: t4,
                  height: r4
                } = this.mediaDimensions;
                h2.x = n(h2.x, 0, t4 - h2.width), h2.y = n(h2.y, 0, r4 - h2.height);
                const s3 = d(h2, t4, r4), a2 = c(h2, t4, r4);
                o2(s3, a2), i2 && i2(s3, a2);
              }
            }, this.onComponentKeyUp = (e3) => {
              this.keysDown.delete(e3.key);
            }, this.onDocPointerDone = (e3) => {
              const {
                crop: t3,
                disabled: r3,
                onComplete: o2,
                onDragEnd: i2
              } = this.props;
              if (this.unbindDocMove(), !r3 && this.mouseDownOnCrop) {
                this.mouseDownOnCrop = false, this.dragStarted = false;
                const {
                  width: r4,
                  height: s2
                } = this.mediaDimensions;
                i2 && i2(e3), o2 && o2(d(t3, r4, s2), c(t3, r4, s2)), this.setState({
                  cropIsActive: false,
                  newCropIsBeingDrawn: false
                });
              }
            }, this.onMediaLoaded = () => {
              const {
                onComplete: e3,
                onChange: t3
              } = this.props, {
                pixelCrop: r3,
                percentCrop: o2
              } = this.createNewCrop();
              t3(r3, o2), e3 && e3(r3, o2);
            }, this.onImageLoad = (e3) => {
              const {
                onComplete: t3,
                onChange: r3,
                onImageLoaded: o2
              } = this.props;
              if ((!o2 || o2(e3.currentTarget)) !== false) {
                const {
                  pixelCrop: e4,
                  percentCrop: o3
                } = this.createNewCrop();
                r3(e4, o3), t3 && t3(e4, o3);
              }
            };
          }
          componentDidMount() {
            this.componentRef.current && this.componentRef.current.addEventListener("medialoaded", this.onMediaLoaded);
          }
          componentWillUnmount() {
            this.componentRef.current && this.componentRef.current.removeEventListener("medialoaded", this.onMediaLoaded);
          }
          componentDidUpdate(e3) {
            const {
              crop: t3,
              onChange: r3,
              onComplete: o2
            } = this.props;
            if (this.imageRef.current && t3 && e3.crop !== t3 && t3.aspect && (t3.width && !t3.height || !t3.width && t3.height)) {
              const {
                width: e4,
                height: t4
              } = this.imageRef.current, i2 = h(this.makeNewCrop(), e4, t4), s2 = d(i2, e4, t4), n2 = c(i2, e4, t4);
              r3(s2, n2), o2 && o2(s2, n2);
            }
          }
          bindDocMove() {
            this.docMoveBound || (document.addEventListener("pointermove", this.onDocPointerMove, l), document.addEventListener("pointerup", this.onDocPointerDone, l), document.addEventListener("pointercancel", this.onDocPointerDone, l), this.docMoveBound = true);
          }
          unbindDocMove() {
            this.docMoveBound && (document.removeEventListener("pointermove", this.onDocPointerMove, l), document.removeEventListener("pointerup", this.onDocPointerDone, l), document.removeEventListener("pointercancel", this.onDocPointerDone, l), this.docMoveBound = false);
          }
          createNewCrop() {
            const {
              width: e3,
              height: t3
            } = this.mediaDimensions, r3 = (o2 = this.makeNewCrop(), i2 = e3, s2 = t3, !o2.aspect || o2.width && o2.height ? o2 : h(o2, i2, s2));
            var o2, i2, s2;
            return {
              pixelCrop: d(r3, e3, t3),
              percentCrop: c(r3, e3, t3)
            };
          }
          get mediaDimensions() {
            let e3 = 0, t3 = 0;
            return this.mediaWrapperRef.current && (e3 = this.mediaWrapperRef.current.clientWidth, t3 = this.mediaWrapperRef.current.clientHeight), {
              width: e3,
              height: t3
            };
          }
          getCropStyle() {
            const e3 = this.makeNewCrop(this.props.crop ? this.props.crop.unit : "px");
            return {
              top: `${e3.y}${e3.unit}`,
              left: `${e3.x}${e3.unit}`,
              width: `${e3.width}${e3.unit}`,
              height: `${e3.height}${e3.unit}`
            };
          }
          getNewSize() {
            const {
              crop: e3,
              minWidth: t3 = 0,
              maxWidth: r3,
              minHeight: o2 = 0,
              maxHeight: i2
            } = this.props, {
              evData: s2
            } = this, {
              width: a2,
              height: h2
            } = this.mediaDimensions;
            let c2, d2 = s2.cropStartWidth + s2.xDiff;
            return s2.xCrossOver && (d2 = Math.abs(d2)), d2 = n(d2, t3, r3 || a2), c2 = e3.aspect ? d2 / e3.aspect : s2.cropStartHeight + s2.yDiff, s2.yCrossOver && (c2 = Math.min(Math.abs(c2), s2.cropStartY)), c2 = n(c2, o2, i2 || h2), e3.aspect && (d2 = n(c2 * e3.aspect, 0, a2)), {
              width: d2,
              height: c2
            };
          }
          dragCrop() {
            const e3 = this.makeNewCrop(), {
              evData: t3
            } = this, {
              width: r3,
              height: o2
            } = this.mediaDimensions;
            return e3.x = n(t3.cropStartX + t3.xDiff, 0, r3 - e3.width), e3.y = n(t3.cropStartY + t3.yDiff, 0, o2 - e3.height), e3;
          }
          resizeCrop() {
            const {
              evData: e3
            } = this, {
              crop: t3,
              minWidth: r3 = 0,
              minHeight: o2 = 0
            } = this.props, i2 = this.makeNewCrop(), {
              ord: s2
            } = e3;
            e3.xInversed && (e3.xDiff -= 2 * e3.cropStartWidth), e3.yInversed && (e3.yDiff -= 2 * e3.cropStartHeight);
            const n2 = this.getNewSize();
            let a2 = e3.cropStartX, h2 = e3.cropStartY;
            e3.xCrossOver && (a2 = i2.x + (i2.width - n2.width)), e3.yCrossOver && (h2 = e3.lastYCrossover === false ? i2.y - n2.height : i2.y + (i2.height - n2.height));
            const {
              width: c2,
              height: d2
            } = this.mediaDimensions, l2 = p(this.props.crop, {
              unit: i2.unit,
              x: a2,
              y: h2,
              width: n2.width,
              height: n2.height,
              aspect: i2.aspect
            }, c2, d2);
            return i2.aspect || u.xyOrds.indexOf(s2) > -1 ? (i2.x = l2.x, i2.y = l2.y, i2.width = l2.width, i2.height = l2.height) : u.xOrds.indexOf(s2) > -1 ? (i2.x = l2.x, i2.width = l2.width) : u.yOrds.indexOf(s2) > -1 && (i2.y = l2.y, i2.height = l2.height), e3.lastYCrossover = e3.yCrossOver, this.crossOverCheck(), i2.width < r3 || i2.height < o2 ? t3 : i2;
          }
          getRotatedCursor(e3, t3) {
            if (t3 > -135 && t3 <= -45 || t3 > 45 && t3 <= 135)
              switch (e3) {
                case "nw":
                  return {
                    cursor: "ne-resize"
                  };
                case "n":
                  return {
                    cursor: "w-resize"
                  };
                case "ne":
                  return {
                    cursor: "nw-resize"
                  };
                case "e":
                  return {
                    cursor: "s-resize"
                  };
                case "se":
                  return {
                    cursor: "sw-resize"
                  };
                case "s":
                  return {
                    cursor: "e-resize"
                  };
                case "sw":
                  return {
                    cursor: "se-resize"
                  };
                case "w":
                  return {
                    cursor: "n-resize"
                  };
              }
          }
          createCropSelection() {
            const {
              disabled: t3,
              locked: r3,
              renderSelectionAddon: o2,
              ruleOfThirds: i2,
              crop: s2,
              spin: n2 = 0
            } = this.props, h2 = this.getCropStyle();
            return (0, e2.jsxs)("div", Object.assign({
              style: h2,
              className: "ReactCrop__crop-selection",
              onPointerDown: this.onCropPointerDown
            }, {
              children: [!t3 && !r3 && (0, e2.jsxs)("div", Object.assign({
                className: "ReactCrop__drag-elements"
              }, {
                children: [(0, e2.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-n",
                  "data-ord": "n"
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-e",
                  "data-ord": "e"
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-s",
                  "data-ord": "s"
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-bar ord-w",
                  "data-ord": "w"
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-nw",
                  "data-ord": "nw",
                  style: this.getRotatedCursor("nw", n2)
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-n",
                  "data-ord": "n",
                  style: this.getRotatedCursor("n", n2)
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-ne",
                  "data-ord": "ne",
                  style: this.getRotatedCursor("ne", n2)
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-e",
                  "data-ord": "e",
                  style: this.getRotatedCursor("e", n2)
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-se",
                  "data-ord": "se",
                  style: this.getRotatedCursor("se", n2)
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-s",
                  "data-ord": "s",
                  style: this.getRotatedCursor("s", n2)
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-sw",
                  "data-ord": "sw",
                  style: this.getRotatedCursor("sw", n2)
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__drag-handle ord-w",
                  "data-ord": "w",
                  style: this.getRotatedCursor("w", n2)
                }, void 0)]
              }), void 0), o2 && a(s2) && (0, e2.jsx)("div", Object.assign({
                className: "ReactCrop__selection-addon",
                onMouseDown: (e3) => e3.stopPropagation()
              }, {
                children: o2(this.state)
              }), void 0), i2 && (0, e2.jsxs)(e2.Fragment, {
                children: [(0, e2.jsx)("div", {
                  className: "ReactCrop__rule-of-thirds-hz"
                }, void 0), (0, e2.jsx)("div", {
                  className: "ReactCrop__rule-of-thirds-vt"
                }, void 0)]
              }, void 0)]
            }), void 0);
          }
          makeNewCrop(e3 = "px") {
            const t3 = {
              ...s,
              ...this.props.crop || {}
            }, {
              width: r3,
              height: o2
            } = this.mediaDimensions;
            return e3 === "px" ? d(t3, r3, o2) : c(t3, r3, o2);
          }
          crossOverCheck() {
            const {
              evData: e3
            } = this, {
              minWidth: t3,
              minHeight: r3
            } = this.props;
            !t3 && (!e3.xCrossOver && -Math.abs(e3.cropStartWidth) - e3.xDiff >= 0 || e3.xCrossOver && -Math.abs(e3.cropStartWidth) - e3.xDiff <= 0) && (e3.xCrossOver = !e3.xCrossOver), !r3 && (!e3.yCrossOver && -Math.abs(e3.cropStartHeight) - e3.yDiff >= 0 || e3.yCrossOver && -Math.abs(e3.cropStartHeight) - e3.yDiff <= 0) && (e3.yCrossOver = !e3.yCrossOver);
          }
          render() {
            const {
              children: t3,
              circularCrop: o2,
              className: i2,
              crossorigin: s2,
              crop: n2,
              disabled: h2,
              imageStyle: c2,
              locked: d2,
              imageAlt: p2,
              onImageError: l2,
              renderComponent: u2,
              scale: f = 1,
              src: g,
              style: m,
              rotate: v = 0,
              ruleOfThirds: w
            } = this.props, {
              cropIsActive: y,
              newCropIsBeingDrawn: C
            } = this.state, x = a(n2) && this.componentRef ? this.createCropSelection() : null, D = function() {
              for (var e3, t4, o3 = 0, i3 = ""; o3 < arguments.length; )
                (e3 = arguments[o3++]) && (t4 = r2(e3)) && (i3 && (i3 += " "), i3 += t4);
              return i3;
            }("ReactCrop", i2, {
              "ReactCrop--active": y,
              "ReactCrop--disabled": h2,
              "ReactCrop--locked": d2,
              "ReactCrop--new-crop": C,
              "ReactCrop--fixed-aspect": n2 && n2.aspect,
              "ReactCrop--circular-crop": n2 && o2,
              "ReactCrop--rule-of-thirds": n2 && w,
              "ReactCrop--invisible-crop": !this.dragStarted && n2 && !n2.width && !n2.height
            });
            return (0, e2.jsxs)("div", Object.assign({
              ref: this.componentRef,
              className: D,
              style: m,
              onPointerDown: this.onComponentPointerDown,
              tabIndex: 0,
              onKeyDown: this.onComponentKeyDown,
              onKeyUp: this.onComponentKeyUp
            }, {
              children: [(0, e2.jsx)("div", Object.assign({
                ref: this.mediaWrapperRef,
                style: {
                  transform: `scale(${f}) rotate(${v}deg)`
                }
              }, {
                children: u2 || (0, e2.jsx)("img", {
                  ref: this.imageRef,
                  crossOrigin: s2,
                  className: "ReactCrop__image",
                  style: c2,
                  src: g,
                  onLoad: this.onImageLoad,
                  onError: l2,
                  alt: p2
                }, void 0)
              }), void 0), t3, x]
            }), void 0);
          }
        }
        u.xOrds = ["e", "w"], u.yOrds = ["n", "s"], u.xyOrds = ["nw", "ne", "se", "sw"], u.nudgeStep = 1, u.nudgeStepMedium = 10, u.nudgeStepLarge = 100;
      })(), i;
    })();
  });
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(ReactCrop_min);
export default __pika_web_default_export_for_treeshaking__;
